import Vue from 'vue';
import VueRouter from 'vue-router';
import { canNavigate } from '@/plugins/acl/routeProtection';
import {
  AUTH_FORGOT_PASSWORD, AUTH_LOGIN, AUTH_REGISTER,
  ERROR_404,
  EVENT_LIST_BY_ESTABLISHMENT,
  EVENT_PAGE, EVENT_PAGE_INVITATION,
} from '@/router/constants';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: EVENT_LIST_BY_ESTABLISHMENT,
    component: () => import('@/views/tss/Event/EventsListLanding.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/event',
    component: () => import('@/views/tss/Event/EventViews/EventPageLanding.vue'),
    children: [
      {
        path: ':eventId/:activeTab?',
        name: EVENT_PAGE,
        component: () => import('@/views/tss/Event/EventViews/EventPage/EventMain/EventMain.vue'),
        meta: {
          layout: 'content',
        },
      },
      {
        path: ':eventId/invitation/:invitationId',
        name: EVENT_PAGE_INVITATION,
        component: () => import('@/views/tss/Event/EventViews/EventPage/InvitationPage/InvitationPage.vue'),
        meta: {
          layout: 'content',
        },
      },
    ],
  },

  {
    path: '/404',
    name: ERROR_404,
    component: () => import('@/views/tss/Basic/Error404.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
    },
  },
  {
    path: '/login',
    name: AUTH_LOGIN,
    component: () => import('@/views/tss/User/Login.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: AUTH_REGISTER,
    component: () => import('@/views/tss/User/Register.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: AUTH_FORGOT_PASSWORD,
    component: () => import('@/views/tss/User/ForgotPassword.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '*',
    redirect: ERROR_404,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach((to, _, next) => {
  const userData = localStorage.getItem('userData');

  const isLoggedIn = userData && localStorage.getItem('accessToken') && localStorage.getItem('userAbility');

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      return next({
        name: 'auth-login',
        query: { marketplace: to.query.marketplace },
      });
    }

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' });

    // return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next('/');
  }

  return next();
});

export default router;
